import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { privateAPI } from "../../../utils/api";
import HideImageIcon from "@mui/icons-material/HideImage";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

const CreateEditGroupDialog = ({ ...props }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [loadingImage, setLoadingImage] = useState(false);

  const handleUpload = async (e) => {
    const file = Array.from(e.target.files)[0];

    // const isImage = /(?:jpg|jpeg|gif|png)/.test(file.type);
    // if (file.size > IMAGE_SIZE) {
    //     setLoading(false);
    //     toast.warn('Image size need to be less than 5mb...');
    //     return;
    // } else if (!isImage) {
    //     setLoading(false);
    //     toast.info('File type need to be jpg, gif or png...');
    //     return;
    // }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoadingImage(true);
      const response = await privateAPI.post(
        "/auth/bacchus/client/image/upload",
        formData
      );
      props.setGroupDTO({ ...props.groupDTO, image: response.data[0] });
      setLoadingImage(false);
    } catch (e) {
      setLoadingImage(false);
    }
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open}
      onClose={props.closeCreateGroupDialog}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        align="center"
        style={{ color: "#001753", marginBottom: "15px" }}
      >
        {props.groupDTO.id ? "Edit group" : "Create new group"}
      </DialogTitle>
      <DialogContent>
        <Box
          component="form"
          sx={{ display: "flex", flexDirection: "column", padding: "10px" }}
          style={{ minWidth: "300px" }}
          autoComplete="off"
        >
          <TextField
            id="outlined-basic"
            label="Title of group"
            variant="outlined"
            placeholder="Title of group"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.groupDTO.name || ""}
            onChange={(e) =>
              props.setGroupDTO({ ...props.groupDTO, name: e.target.value })
            }
          />
          <TextField
            id="outlined-basic"
            label="Title on German"
            variant="outlined"
            placeholder="Title on German"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.groupDTO.name_de || ""}
            onChange={(e) =>
              props.setGroupDTO({ ...props.groupDTO, name_de: e.target.value })
            }
          />
          <TextField
            id="outlined-basic"
            label="Title on French"
            variant="outlined"
            placeholder="Title on French"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.groupDTO.name_fr || ""}
            onChange={(e) =>
              props.setGroupDTO({ ...props.groupDTO, name_fr: e.target.value })
            }
          />
          <TextField
            id="outlined-basic"
            label="Title on Italian"
            variant="outlined"
            placeholder="Title on Italian"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.groupDTO.name_it || ""}
            onChange={(e) =>
              props.setGroupDTO({ ...props.groupDTO, name_it: e.target.value })
            }
          />
          <TextField
            id="outlined-multiline-flexible"
            label="Description of group"
            placeholder="Description of group"
            style={{ marginBottom: "25px", width: "100%" }}
            multiline
            value={props?.groupDTO.description || ""}
            onChange={(e) =>
              props.setGroupDTO({
                ...props.groupDTO,
                description: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-multiline-flexible"
            label="Description on German"
            placeholder="Description on German"
            style={{ marginBottom: "25px", width: "100%" }}
            multiline
            value={props?.groupDTO.description_de || ""}
            onChange={(e) =>
              props.setGroupDTO({
                ...props.groupDTO,
                description_de: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-multiline-flexible"
            label="Description on French"
            placeholder="Description on French"
            style={{ marginBottom: "25px", width: "100%" }}
            multiline
            value={props?.groupDTO.description_fr || ""}
            onChange={(e) =>
              props.setGroupDTO({
                ...props.groupDTO,
                description_fr: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-multiline-flexible"
            label="Description on Italian"
            placeholder="Description on Italian"
            style={{ marginBottom: "25px", width: "100%" }}
            multiline
            value={props?.groupDTO.description_it || ""}
            onChange={(e) =>
              props.setGroupDTO({
                ...props.groupDTO,
                description_it: e.target.value,
              })
            }
          />
          {props.groupDTO.image?.includes("https://res.cloudinary.com") ? (
            <img
              src={props.groupDTO.image}
              alt={props.groupDTO.name}
              style={{ height: "100px", width: "100%", margin: "0 auto 25px" }}
            />
          ) : (
            <HideImageIcon
              style={{
                height: "50px",
                width: "50px",
                color: "#001753 !important",
                margin: "0 auto 25px",
              }}
            />
          )}
          <Button variant="contained" component="label">
            Upload group image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleUpload(e)}
            />
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeCreateGroupDialog}>
          Close
        </Button>
        <Button
          onClick={props.groupDTO.id ? props.editGroup : props.crateNewGroup}
          autoFocus
        >
          {props.groupDTO.id ? "Edit" : "Create"}
        </Button>
      </DialogActions>
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loadingImage}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default CreateEditGroupDialog;
